import React, { useEffect, useState } from "react";
import Navbar from "../component.js/landPage/Navbar";
import { ArrowRight } from "iconsax-react";
import { Autoplay } from "swiper/modules";

import ScrollAnimation from "react-animate-on-scroll";
import { Swiper, SwiperSlide } from "swiper/react";
import { useForm, ValidationError } from "@formspree/react";
import { ClipLoader } from "react-spinners";

const HomePage = () => {
  const texts = ["Defend.", "Adapt.", "Thrive."];
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    message: "",
  });
  const [state, handleSubmit] = useForm("mqaawzvq");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  useEffect(() => {
    if (state.succeeded) {
      setLoading(false);
      setFormData({
        name: "",
        email: "",
        phoneNumber: "",
        message: "",
      });
      setSuccessMessage("Form submitted successfully!");
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000); // Show success message for 3 seconds before hiding it
    }
  }, [state.succeeded]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };



  return (
    <div className="relative">
      <Navbar />
      <section className="flex flex-col-reverse md:flex-row mt-[69px] md:mt-[86px] lg:mt-[95px]  py-[32px] md:py-[52px] lg:py-[60px] px-[26px] md:px-[42px] lg:px-[58px] gap-[30px] md:gap-[80px] xl:gap-[140px] ">
        <div className="w-full md:w-[50%] relative">
          <img
            src="./asset/heroImage.png"
            className="h-[360px] md:h-[520px] lg:h-[600px] mx-auto "
            alt=""
          />

          <div className="px-[18px] py-[13px] rounded-[16px] shadow absolute -bottom-16 right-0 md:-right-20 z-10 bg-[#fff] max-w-[250px] md:max-w-[280px] lg:max-w-[300px]">
            <p className="md:text-[18px] lg:text-[20px] mb-2 ">
              <span className="font-semibold ">Blessing . </span>
              <span className="italic">ceo</span>
            </p>
            <p className="text-[#4F4F4F] md:text-[18px] lg:text-[20px]">
              I can relax and go on needed vacation cause, Infohint has my back
              always.
            </p>
          </div>
        </div>

        <div className="w-full md:w-[50%]">
          <div className="bg-[#EED200] text-center mx-auto md:mx-0 px-[18px] py-[12px] rounded-[100px] text-[12px] max-w-[223px] md:max-w-[286px]">
            <p>**Trusted by 200+ businesses**</p>
          </div>

          <div className=" h-[110px] lg:h-[130px] xl:h-[150px] mt-4 overflow-hidden">
            <Swiper
              spaceBetween={50}
              direction="vertical"
              modules={[Autoplay]}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              effect="fade"
              fadeEffect={{
                crossFade: true,
              }}
              loop={true}
              speed={900}
              className="h-full w-full"
            >
              {texts.map((word, index) => (
                <SwiperSlide
                  key={index}
                  className="text-center md:text-left flex items-center pt-6 lg:pt-9 xl:pt-[44px]  justify-center"
                >
                  <span className=" text-[60px] md:text-[68px] lg:text-[78px] lg:leading-[74px] xl:text-[96px] xl:leading-[96px] text-[#140152] fonte">
                    {word}
                  </span>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <p className="text-[#4F4F4F] px-5 md:px-0 text-[14px] md:text-[18px] text-center md:text-left lg:text-[20px] ">
            We are Infohint, your trusted cybersecurity partner. We offer expert
            solutions to protectyour business from evolving threats, with
            tailored services in defense, threat intelligence, and compliance to
            secure your digital future.
          </p>
          <div className="flex justify-center md:justify-start">
            <button className="mt-[21px] md:mt-[32px] self-center md:mx-0 bg-[#140152] text-[#D5C9FF] hover:bg-opacity-80 relative rounded-[50px] py-[20px] lg:py-[32px] pl-[39px] w-[301px] lg:w-[336px]">
              <p className="text-[14px] md:text-[16px] text-left">
                Join the secured team
              </p>
              <div className="absolute rounded-full top-[2px] right-1 h-[56px] w-[56px] lg:top-[4px] lg:h-[80px] lg:w-[80px] flex justify-center items-center bg-[#563CAF]">
                <ArrowRight color="white" className=" -skew-y-12 skew" />
              </div>
            </button>
          </div>
        </div>
      </section>

      <section className="relative mt-[40px] block md:hidden lg:mt-[60px] h-[90px]  -mb-2 ">
        <img src="./asset/shortslide1.png" alt="" className="absolute  z-10 " />
        <img src="./asset/shortslide2.png" alt="" className="absolute  z-20" />
      </section>

      <section className="relative hidden md:block mt-[40px] lg:mt-[60px] md:h-[90px] xl:h-[90px]   lg:h-[70px] -mb-2 ">
        <img src="./asset/slide1.png" alt="" className="  z-30 " />
        <img src="./asset/slide2.png" alt="" className="absolute -top-6 z-20" />
      </section>

      <section
        id="service"
        className="relative -z-10 pt-[88px] pb-[58px] sm:pt-[100px] md:py-[124px] bg-[#140152] px-[24px] md:px-[52px] lg:px-[80px] xl:px-[180px]"
      >
        <img
          src="./asset/servicebg.png"
          alt="servicebg"
          className="absolute top-0 left-0 object-cover -z-10 h-full w-full"
        />
        <div className="z-10">
          <ScrollAnimation
            animateIn="animate__fadeInLeft"
            animateOut="animate__fadeOutRight"
            duration={1.2}
          >
            <div className="flex flex-col md:flex-row md:flex-center">
              <p className="text-[24px] whitespace-nowrap text-[#CBD6FF] md:text-[32px] lg:text-[40px] font-medium">
                Our Services –
              </p>
              <p className="text-[18px] mt-2 fonte text-[#FFFFFF] md:text-[28px] lg:text-[32px] font-normal forte">
                Designed For Your Security
              </p>
            </div>
          </ScrollAnimation>

          <div className="mt-12 md:mt-16">
            <div>
              <ScrollAnimation animateIn="fadeInUp" duration={2}>
                <div>
                  <h2 className="forte text-[#fff] fonte ">
                    Security Defense Operations
                  </h2>
                  <p className="text-[#ACACAC]   text-[14px] md:text-[16px]  mt-3 md:mt-5 max-w-[463px]">
                    We monitor your systems round-the-clock, detect threats in
                    real-time, and respond swiftly to keep you secure. With
                    advanced analytics, we identify vulnerabilities before they
                    become risks.
                  </p>
                </div>
              </ScrollAnimation>
            </div>
            <ScrollAnimation
              animateIn="fadeInUp"
              duration={1.4}
              className="mt-12 md:mt-16"
            >
              <div className="flex mt-6 ">
                <div className="w-[60%] hidden md:block"></div>
                <div>
                  <h2 className="forte text-[#fff] fonte ">
                    Penetration Testing{" "}
                  </h2>
                  <p className="text-[#ACACAC]   text-[14px] md:text-[16px]  mt-5 max-w-[463px]">
                    We simulate real-world attacks to uncover weak spots in your
                    systems. Our tests help prioritize fixes, ensuring your
                    defenses are always a step ahead.{" "}
                  </p>
                </div>
              </div>

            </ScrollAnimation>
            <ScrollAnimation
              animateIn="fadeInUp"
              duration={1.4}
              className="mt-12 md:mt-16"
            >
              <div className="flex mt-6 ">
                <div className="w-[5%] hidden md:block"></div>
                <div>
                  <h2 className="forte text-[#fff] fonte ">
                    Threat Intelligence
                  </h2>
                  <p className="text-[#ACACAC]   text-[14px] md:text-[16px]  mt-5 max-w-[463px]">
                    Stay ahead of cyber threats with actionable insights
                    tailored to your industry. We analyze emerging risks to help
                    you prepare and defend against advanced attacks.
                  </p>
                </div>
              </div>
            </ScrollAnimation>

            <ScrollAnimation
              animateIn="fadeInUp"
              duration={1.4}
              className="mt-12 md:mt-16"
            >
              <div className="flex mt-6  ">
                <div className="w-[73%] hidden md:block"></div>
                <div>
                  <h2 className="forte text-[#fff] fonte ">
                    Security Compliance
                  </h2>
                  <p className="text-[#ACACAC]   text-[14px] md:text-[16px] max-w-[463px]  mt-5 ">
                    Navigate regulatory standards with ease. From ISO 27001 to
                    GDPR, we guide you through audits, policies, and
                    certifications, building trust and minimizing risks. Your
                    security is our priority Infohint is here to keep you
                    protected.
                  </p>
                </div>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </section>

      <section
        id="contact"
        className="py-[52px] md:py-[88px] lg:py-[120px] px-[30px]"
      >
        <div className="w-full md:max-w-[500px] lg:max-w-[570px]   xl:max-w-[691px] mx-auto">
          <ScrollAnimation
            animateIn="animate__fadeInLeft"
            animateOut="animate__fadeOutRight"
            duration={1.3}
          >
            <div className="flex flex-col md:flex-row md:flex-center gap-2  md:gap-5">
              <p className="text-[18px] mt-2 whitespace-nowrap  fonte text-[#140152] md:text-[28px] lg:text-[32px] font-normal forte">
                Get in touch
              </p>
              <p className="text-[14px]  text-[#757575] md:text-[16px] lg:text-[20px] ">
                Have questions or need assistance ?<br /> Our team is readily
                available to assist you.
              </p>
            </div>
          </ScrollAnimation>

          <div className="mt-[51px] md:mt-[70px] lg:mt-[100px] md:px-3 lg:px-5 ">
            <form
              onSubmit={handleSubmit}
              className="md:bg-[#FCFCFC] rounded-md md:py-3 lg:py-5 md:px-3"
            >
              <div className="flex flex-col gap-[60px] lg:gap-[70px]">
                <input
                  type="text"
                  className="border-b-2 border-[#EEEEEE]  py-[10px] px-[20px] text-[#140152] focus:outline-none focus:border-b-[#cbcaca]"
                  placeholder="Your name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                <input
                  className="border-b-2 border-[#EEEEEE]  py-[10px] px-[20px] text-[#140152] focus:outline-none focus:border-b-[#cbcaca]"
                  placeholder="Email "
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  className="border-b-2 border-[#EEEEEE]  py-[10px] px-[20px] text-[#140152] focus:outline-none focus:border-b-[#cbcaca]"
                  placeholder="Phone number"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  className="border-b-2 border-[#EEEEEE]  py-[10px] px-[20px] text-[#140152] focus:outline-none focus:border-b-[#cbcaca]"
                  placeholder="Your message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>
              <p className="text-[13px] text-green-500">{successMessage}</p>
              <div className="flex justify-end mt-[31px] ">
                <button
                  type="submit"
                  onClick={() => setLoading(true)}
                  className="text-[16px] text-[#D5C9FF] bg-[#140152] hover:bg-[#0F003C] py-[12px] px-[32px] md:px-[56px] lg:px-[76px] rounded-[80px] font-normal"
                >
                  {loading ? (
                    <ClipLoader color={"white"} size={20} />
                  ) : (
                    <> Submit </>
                  )}
                </button>
              </div>
              <ValidationError
                prefix="Message"
                field="message"
                errors={state.errors}
              />
            </form>
          </div>
        </div>
      </section>

      <section className="bg-[#140152] py-6 md:py-8 text-[#fff]">
        {" "}
        <p className="text-center">Infohint 2024</p>{" "}
      </section>
    </div>
  );
};

export default HomePage;
